import { useCreateAccountReceivable } from 'api-hooks/account-receivable';
import { ReceiptModel } from 'api-hooks/receipt';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { SeparatorVertical } from 'legacy-modules/styles';
import { NavigationProps } from 'types';

import AccountReceivableForm from './components/form';

export type AccountReceivableCreateParams = {
  receipt?: ReceiptModel;
};

export default function AccountReceivableCreate(
  props: NavigationProps<NavigationRoutes.AccountReceivablesCreate>,
) {
  const { mutateAsync, error } = useCreateAccountReceivable();

  const receipt = props.navigation.params?.receipt;

  const onResolve = useApprovalableEdit('account-receivables');

  return (
    <>
      {!!error && !!error.message && (
        <>
          <Notification
            overrides={{
              Body: { style: { width: 'auto', wordBreak: 'break-all' } },
            }}
            kind={KIND.negative}
            closeable
          >
            {() => error.message}
          </Notification>
          <SeparatorVertical $margin={8} />
        </>
      )}
      <AccountReceivableForm
        {...props}
        receiptData={receipt}
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);
          onResolve(result);
          return result.data;
        }}
      />
    </>
  );
}
